import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {concatMap, tap, mapTo} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {AuthResponse} from '../../shared/models/auth.model';
import {ReservationService} from '../api/reservation.service';
import {HttpCacheService} from '../services/http-cache.service';
import {ApiConfigService} from '../api/api.config.service';
import {GlobalErrorService} from '../services/global-error.service';
import {silentHttp} from '../interceptors/http-api-scope';

@Injectable({providedIn: 'root'})
export class AuthService {
  constructor(
    private http: HttpClient,
    private hoomvipStorage: HoomvipStorage,
    private reservationService: ReservationService,
    private cache: HttpCacheService,
    private apiConfig: ApiConfigService,
  ) {
  }

  login(code: string): Observable<AuthResponse> {
    return this.http
      .post<AuthResponse>(this.apiConfig.getLoginPath(), {code}, silentHttp())
      .pipe(
        tap(res => this.hoomvipStorage.setSession(res.access_token, code)),
        concatMap(authResponse =>
          this.reservationService.getReservation().pipe(mapTo(authResponse))
        )
      );
  }

  logout(): void {
    this.cache.invalidate();
    this.hoomvipStorage.clear();
  }

  get token(): string | null {
    return this.hoomvipStorage.getToken();
  }

  get isLoggedIn(): boolean {
    return !!this.token;
  }
}
